<div class="modal-header flex flex-row space-between">
  <h4 class="modal-title">Sélection de ligne d'équipement</h4>

  <button class="btn btn-default" (click)="modal.close(undefined)">
    Aucun équipement correspondant
  </button>
</div>

<div class="modal-body">
  <p-table #dt [value]="items" class="wcm-table">
    <ng-template pTemplate="header">
      <tr>
        <th class="text-left">Constructeur</th>
        <th class="text-left">Modèle</th>
        <th style="width: 10%;"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-ri="rowIndex">
      <tr>
        <td>{{ item.model.brand.name }}</td>
        <td>{{ item.model.name }}</td>
        <td class="text-center">
          <div class="action-btn-bar">
            <button type="button" class="btn btn-default btn-xs" (click)="modal.close(item)">
              Sélectionner
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
